<template>
  <v-container class="pb-0">
    <v-row>
      <v-col cols="auto" class="pl-4 pr-0 py-0 text-center">
        <div class="caption">100</div>
        <v-slider
          :value="coreCard.value / 2 + 50"
          vertical
          disabled
          width="12"
          :thumb-color="label.color"
        ></v-slider>
        <div class="caption">-100</div>
      </v-col>
      <v-col
        class="my-auto pl-0 border--background border--thin rounded-lg mx-4"
      >
        <v-row>
          <v-col cols="5" class="text-center secondary--text pr-0">
            <div class="font-weight-bold">eNPS</div>
            <div class="text-h3">{{ coreCard.value | no_decimal }}</div>
            <div :class="`caption`" v-bind:style="{ color: label.color }">
              {{ label.label }}
            </div>
          </v-col>
          <v-col cols="7" class="pl-0">
            <v-row>
              <v-col
                cols="12"
                v-for="(item, i) in coreCard.eNPSItems"
                :key="i"
                class="pt-0 d-flex align-center"
              >
                <v-icon
                  :color="$coreScores.getEnpsLabelByColumn(item.type).color"
                  class="mr-2"
                  small
                >
                  {{ $coreScores.getEnpsLabelByColumn(item.type).icon }}
                </v-icon>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-progress-linear
                      class="rounded-sm"
                      :value="(item.count / total) * 100"
                      background-color="background"
                      :color="$coreScores.getEnpsLabelByColumn(item.type).color"
                      height="15"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <template v-slot:default="{ value }">
                        <strong class="secondary--text">
                          {{ Math.round(value) }}%
                        </strong>
                      </template>
                    </v-progress-linear>
                  </template>
                  <span class="pa-2">{{
                    $coreScores.getEnpsLabelByColumn(item.type).name
                  }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "CoreCardEnps",
  props: { coreCard: { type: Object } },
  computed: {
    total() {
      return this._.sumBy(this.coreCard.eNPSItems, "count");
    },
    label() {
      return this.$coreScores.getEnpsLabel(this.coreCard.value);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-slider {
    &.v-slider--vertical {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      min-height: 100px !important;

      .v-slider__track-container {
        width: 6px !important;
      }
    }

    .v-slider__track-background,
    .v-slider__track-fill {
      background: var(--v-lighttext-base) !important;
    }
  }
}
</style>
